// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"c342f9574d137fb9","35":"f966e48fb17b1533","793":"42ef63b7ec463244","834":"55a10ad4b00f1edb"}[chunkId] + ".js";
};